// These auxiliaries are filtered from the beginning of word combinations in the prominent words.
export const filteredAuxiliaries =  [
	"být",
	"byl",
	"byla",
	"bylo",
	"byli",
	"byly",
	"je",
	"jsem",
	"jsi",
	"jste",
	"jste",
	"jsme",
	"jste",
	"jsou",
	"budu",
	"budeš",
	"budete",
	"bude",
	"budeme",
	"budete",
	"budou",
	"nebyl",
	"nebyla",
	"nebylo",
	"nebyli",
	"nebily",
	"nebudu",
	"nebudeš",
	"nebudete",
	"nebude",
	"nebudeme",
	"nebudete",
	"nebudou",
];

export default filteredAuxiliaries;
